import React from 'react';
import { WarningOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import OverdueInvoicesBanner from './OverdueInvoicesBanner';

interface Props {
  isAdminUser: boolean;
  hasOverdueInvoices: boolean;
}

const HomeTopBanner: React.FC<Props> = ({
  isAdminUser,
  hasOverdueInvoices,
}) => (
  <div>
    {hasOverdueInvoices && (
      <Alert
        title={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              gap: '14px',
            }}
          >
            <WarningOutlined style={{ fontSize: '28px', color: '#ff4d4f' }} />
            <OverdueInvoicesBanner isAdminUser={isAdminUser} />
          </div>
        }
        type="error"
        showIcon={false}
        closable
        style={{ paddingRight: '34px' }} // Moves the cross button to the left for alignment
      />
    )}
  </div>
);

export default HomeTopBanner;
